
export default {
  path: '/download',
  name: 'download',
  component: () => import('@/view/download/index.vue'),
  meta: {
    name: 'download',
    token: false,
  }
};
